export default [
  {
    path: '/jcxz',
    component: () => import('./views/index')
  },
  {
    path: '/jcxz/detail',
    component: () => import('./views/detail')
  },
  {
    path: '/jcxz/search',
    component: () => import('./views/search')
  }
]



// WEBPACK FOOTER //
// ./src/page/jcxz/router.js